/**
 * @generated SignedSource<<f737368797c7d2c68513aa688c548b7a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ServicePageReviews_productizedService$data = {
  readonly userProfile: {
    readonly reviews: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly commentOnlyVisibleToRecipient: boolean;
          readonly isPositiveReview: boolean;
          readonly onlyVisibleToRecipient: boolean;
          readonly rating: number;
        };
      }>;
    };
    readonly " $fragmentSpreads": FragmentRefs<"UserReviews_userProfile">;
  };
  readonly " $fragmentSpreads": FragmentRefs<"ServiceCheckout_productizedService" | "ServicePageCheckoutHeader_productizedService">;
  readonly " $fragmentType": "ServicePageReviews_productizedService";
};
export type ServicePageReviews_productizedService$key = {
  readonly " $data"?: ServicePageReviews_productizedService$data;
  readonly " $fragmentSpreads": FragmentRefs<"ServicePageReviews_productizedService">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ServicePageReviews_productizedService",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ServicePageCheckoutHeader_productizedService"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ServiceCheckout_productizedService"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "UserProfile",
      "kind": "LinkedField",
      "name": "userProfile",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "UserReviews_userProfile"
        },
        {
          "alias": "reviews",
          "args": [
            {
              "kind": "Literal",
              "name": "filter",
              "value": {
                "isPositiveReview": true,
                "onlyVisibleToRecipient": false
              }
            }
          ],
          "concreteType": "UserReviewConnection",
          "kind": "LinkedField",
          "name": "userReviews",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "UserReviewEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "UserReview",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "commentOnlyVisibleToRecipient",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "onlyVisibleToRecipient",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "isPositiveReview",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "rating",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": "userReviews(filter:{\"isPositiveReview\":true,\"onlyVisibleToRecipient\":false})"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ProductizedService",
  "abstractKey": null
};

(node as any).hash = "e47afa8d6a187443ae960de6d4fcaacf";

export default node;
